import { render } from "./KeywordResult.vue?vue&type=template&id=2a5c46f6"
import script from "./KeywordResult.vue?vue&type=script&lang=js"
export * from "./KeywordResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__